import { useState } from 'react';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button
} from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { API } from '../../../config/config';
// import fetchWithAuth from "../../../FetchWithAuth";
import { useAuth } from 'src/hooks/useAuth';

const MainContent = styled(Box)(
  ({ theme }) => `
    height: 100%;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);

function StaffSignUpForm({ accessToken }) {
  const { enhancedFetch } = useAuth();
  const [registrationCode, setRegistrationCode] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`
  };

  const onSubmit = () => {
    enhancedFetch(`${API.HOST}/api/v1/users/register/staff`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        code: registrationCode
      })
    }).then(
      (response) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('displayName', `${firstName} ${lastName}`);
        window.location.href = '/product';
        window.location.reload();
      },
      (error) => {
        //TODO: Error notification
      }
    );
  };

  return (
    <>
      <MainContent>
        <Container maxWidth="xs" style={{ marginTop: '20px' }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12}>
              <Card>
                <CardHeader title="Complete Registration" />
                <Divider />
                <CardContent>
                  <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <TextField
                      style={{ width: '300px', marginBottom: '15px' }}
                      required
                      id="outlined-required"
                      label="First Name"
                      defaultValue=""
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                    />
                    <TextField
                      style={{ width: '300px', marginBottom: '15px' }}
                      required
                      id="outlined-required"
                      label="Last Name"
                      defaultValue=""
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                    />
                    <TextField
                      style={{ width: '300px', marginBottom: '15px' }}
                      required
                      id="outlined-required"
                      label="Phone Number"
                      defaultValue=""
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                      }}
                    />
                    <TextField
                      style={{ width: '300px', marginBottom: '15px' }}
                      required
                      id="outlined-required"
                      label="Registration code"
                      defaultValue=""
                      value={registrationCode}
                      onChange={(e) => {
                        setRegistrationCode(e.target.value);
                      }}
                    />
                    <Button
                      style={{ marginTop: '30px', width: '300px' }}
                      href="#"
                      variant="contained"
                      onClick={onSubmit}
                    >
                      Submit
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </MainContent>
    </>
  );
}

export default StaffSignUpForm;
